import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Header from "components/Header/index";
import Sidebar from "containers/SideNav/index";
import Footer from "components/Footer";
import Widgets from "./routes/widgets";
import Metrics from "./routes/metrics";
import Components from "./routes/components";
import Icons from "./routes/icons/index";
import Form from "./routes/form";
import Editors from "./routes/editors";
import Pickers from "./routes/pickers";
import Extensions from "./routes/extensions";
import Table from "./routes/table";
import Chart from "./routes/charts";
import Map from "./routes/map";
import Calendar from "./routes/calendar";
import TimeLine from "./routes/timeLine";
import CustomViews from "./routes/customViews";
import ExtraElements from "./routes/extraElements";
import eCommerce from "./routes/eCommerce";
import AppModule from "./routes/appModule";
import ExtraPages from "./routes/extraPages";
import TradingAccounts from "./routes/tradingAccounts";
import Advisors from "./routes/advisors";
import ManageRoles from "./routes/roles";
import CashMovement from "./routes/cashMovement";
import UserAccounts from "./routes/userAccounts";
import Tour from "../components/Tour/index";
import Restrictions from "./routes/restrictions";
import Notification from "./routes/notification";

import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";

import { isIOS, isMobile } from "react-device-detect";
import asyncComponent from "../util/asyncComponent";
import TopNav from "components/TopNav";
import SocialApps from "./routes/socialApps";
import BankAccounts from "./routes/bankaccounts";
import Compliance from "./routes/compliance";
import Users from "./routes/users";
import GenerateUserAssetReport from "./routes/generateuser&assetreport";
import Operations from "./routes/operations";
import Symbols from "./routes/symbols";
import Smartfolio from "./routes/smartfolio";
import SmartfolioAccuracy from "./routes/smartfolioAccuracy";
import ServiceCenter from "./routes/serviceCenter";
import AccountTransfers from "./routes/accountTransfers";
import ChurnPrevention from "./routes/churnPrevention";
import WorkflowOperations from "./routes/workflowOperations";
import QualityControl from "./routes/qualityControl";
import Abr from "./routes/abr";


class App extends React.Component {
  render() {
    const {
      match,
      drawerType,
      navigationStyle,
      horizontalNavPosition,
    } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "fixed-drawer"
      : drawerType.includes(COLLAPSED_DRAWER)
      ? "collapsible-drawer"
      : "mini-drawer";

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add("ios-mobile-view-height");
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
      document.body.classList.remove("ios-mobile-view-height");
    }

    return (
      <div className={`app-container ${drawerStyle}`}>
        <Tour />

        <Sidebar />
        <div className="app-main-container">
          <div
            className={`app-header ${
              navigationStyle === HORIZONTAL_NAVIGATION
                ? "app-header-horizontal"
                : ""
            }`}
          >
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === ABOVE_THE_HEADER && (
                <TopNav styleName="app-top-header" />
              )}
            <Header />
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                <Route
                  path={`${match.url}/manageRoles`}
                  component={ManageRoles}
                />
                <Route
                  path={`${match.url}/userAccounts`}
                  component={UserAccounts}
                />
                <Route
                  path={`${match.url}/tradingAccounts`}
                  component={TradingAccounts}
                />
                <Route
                  path={`${match.url}/advisors`}
                  component={Advisors}
                />
                <Route
                  path={`${match.url}/bankaccounts`}
                  component={BankAccounts}
                />
                <Route
                  path={`${match.url}/cashMovement`}
                  component={CashMovement}
                />
                <Route
                  path={`${match.url}/compliance`}
                  component={Compliance}
                />
                <Route
                  path={`${match.url}/operations`}
                  component={Operations}
                />
                <Route
                  path={`${match.url}/trades/:tradeSagaId?`}
                  render={({ match: routeMatch }) => {
                    const tradeSagaId = routeMatch.params.tradeSagaId;
                    return (
                      <Redirect
                        to={
                          tradeSagaId
                            ? `${match.url}/workflow-operations/trades/${tradeSagaId}`
                            : `${match.url}/workflow-operations/control-tower`
                        }
                      />
                    );
                  }}
                />
                <Route
                  path={`${match.url}/orders`}
                  render={() => (
                    <Redirect to={`${match.url}/workflow-operations/control-tower`} />
                  )}
                />
                <Route
                  path={`${match.url}/smartfolio`}
                  component={Smartfolio}
                />
                <Route
                  path={`${match.url}/smartfolio-accuracy`}
                  component={SmartfolioAccuracy}
                />
                <Route
                  path={`${match.url}/service-center`}
                  component={ServiceCenter}
                />
                <Route
                  path={`${match.url}/account-transfers`}
                  component={AccountTransfers}
                />
                <Route
                  path={`${match.url}/churn-prevention`}
                  component={ChurnPrevention}
                />
                <Route
                  path={`${match.url}/workflow-operations`}
                  component={WorkflowOperations}
                />
                <Route
                  path={`${match.url}/quality-control`}
                  component={QualityControl}
                />
                <Route
                  path={`${match.url}/abr`}
                  component={Abr}
                />
                <Route path={`${match.url}/users`} component={Users} />
                <Route
                  path={`${match.url}/restrictions`}
                  component={Restrictions}
                />
                <Route
                  path={`${match.url}/social-apps`}
                  component={SocialApps}
                />
                <Route
                  path={`${match.url}/components`}
                  component={Components}
                />
                <Route path={`${match.url}/icons`} component={Icons} />
                <Route path={`${match.url}/form`} component={Form} />
                <Route path={`${match.url}/editor`} component={Editors} />
                <Route path={`${match.url}/pickers`} component={Pickers} />
                <Route
                  path={`${match.url}/extensions`}
                  component={Extensions}
                />
                <Route path={`${match.url}/table`} component={Table} />
                <Route path={`${match.url}/chart`} component={Chart} />
                <Route path={`${match.url}/map`} component={Map} />
                <Route path={`${match.url}/calendar`} component={Calendar} />
                <Route path={`${match.url}/time-line`} component={TimeLine} />
                <Route
                  path={`${match.url}/custom-views`}
                  component={CustomViews}
                />
                <Route path={`${match.url}/widgets`} component={Widgets} />
                <Route path={`${match.url}/metrics`} component={Metrics} />
                <Route
                  path={`${match.url}/extra-elements`}
                  component={ExtraElements}
                />
                <Route path={`${match.url}/ecommerce`} component={eCommerce} />
                <Route path={`${match.url}/app-module`} component={AppModule} />
                <Route
                  path={`${match.url}/to-do`}
                  component={asyncComponent(() =>
                    import("./routes/todo/basic/index")
                  )}
                />
                <Route
                  path={`${match.url}/to-do-redux`}
                  component={asyncComponent(() =>
                    import("./routes/todo/redux/index")
                  )}
                />
                <Route
                  path={`${match.url}/mail`}
                  component={asyncComponent(() =>
                    import("./routes/mail/basic/index")
                  )}
                />
                <Route
                  path={`${match.url}/mail-redux`}
                  component={asyncComponent(() =>
                    import("./routes/mail/redux/index")
                  )}
                />
                <Route
                  path={`${match.url}/chat`}
                  component={asyncComponent(() =>
                    import("./routes/chatPanel/basic/index")
                  )}
                />
                <Route
                  path={`${match.url}/chat-redux`}
                  component={asyncComponent(() =>
                    import("./routes/chatPanel/redux/index")
                  )}
                />
                <Route
                  path={`${match.url}/contact`}
                  component={asyncComponent(() =>
                    import("./routes/contact/basic/index")
                  )}
                />
                <Route
                  path={`${match.url}/contact-redux`}
                  component={asyncComponent(() =>
                    import("./routes/contact/redux/index")
                  )}
                />
                <Route
                  path={`${match.url}/user&AssetReport`}
                  component={GenerateUserAssetReport}
                />
                <Route
                  path={`${match.url}/notification`}
                  component={Notification}
                />
                <Route path={`${match.url}/symbols`} component={Symbols} />
                <Route
                  path={`${match.url}/extra-pages`}
                  component={ExtraPages}
                />
                <Route
                  component={asyncComponent(() =>
                    import("app/routes/extraPages/routes/404")
                  )}
                />
              </Switch>
            </div>
            <Footer />
          </main>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  return { drawerType, navigationStyle, horizontalNavPosition };
};
export default withRouter(connect(mapStateToProps)(App));
